export default __webpack_public_path__ + "static/m-customer3-f8b6a5e0c7448fe3cf2e1a8e125ea1eb.png";